import LanguageIcon from '@mui/icons-material/Language';
import { Box, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import { SUPPORTED_LANGUAGES, useTranslation } from '../../i18n';

/** Compact EN/VI language picker for the app bar (persists via i18n). */
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('vi') ? 'vi' : 'en';

  const handleChange = (event: SelectChangeEvent) => {
    void i18n.changeLanguage(event.target.value);
  };

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#fff' }}
    >
      <LanguageIcon fontSize="small" sx={{ color: '#fff' }} />
      <Select
        value={current}
        onChange={handleChange}
        variant="standard"
        disableUnderline
        aria-label="Select language"
        sx={{
          color: '#fff',
          fontWeight: 600,
          '& .MuiSelect-select': { py: 0, pr: '20px !important' },
          '& .MuiSelect-icon': { color: '#fff' },
        }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem key={language.code} value={language.code}>
            {language.code.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;
